/**
 * Cart-item selection helpers.
 *
 * ATL-565: `onDonePress` in AddCartItemScreen used to call
 * `initialCartItems.every(...)` directly. When the screen is re-mounted/restored
 * by React Navigation without route params, `initialCartItems` is `undefined` and
 * `.every` throws a fatal "Cannot read property 'every' of undefined". Centralizing
 * the dedup here with array guards makes the path crash-proof and unit-testable.
 */

/**
 * Returns the subset of `selectedItems` that are NOT already present in
 * `initialCartItems` (compared by `id`). Tolerates undefined/non-array inputs.
 *
 * @param {Array<{id: string}>} selectedItems  items the user just selected
 * @param {Array<{id: string}>} initialCartItems  items already in the cart
 * @returns {Array<{id: string}>}
 */
export const getNewCartItems = (selectedItems = [], initialCartItems = []) => {
  const selected = Array.isArray(selectedItems) ? selectedItems : []
  const initial = Array.isArray(initialCartItems) ? initialCartItems : []
  return selected.filter(item => initial.every(existing => existing.id !== item.id))
}
